export function match(param: string) {
  const categories = [
    "basic-fields",
    "survey-fields",
    "special-fields",
  ];
  return categories.includes(param);
}
